
import Reception from '../../components/ReceptionComponent.vue';

export default {
  name: 'ReceptionMobile',
  components: {
    Reception,
  },
};
